import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-900 border-t border-background-800/50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-movie-2-line text-xl text-primary-500"></i>
              </div>
              <span className="text-lg font-heading font-bold text-foreground-50">
                成全<span className="text-primary-500">影院</span>
              </span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed mb-4">
              成全影院为您提供海量免费电影、电视剧、综艺、动漫在线观看。高清画质，流畅不卡顿，每日更新热门影视资源。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">视频分类</h4>
            <div className="flex flex-col gap-2.5">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.id}`}
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">关于我们</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                品牌介绍
              </Link>
              <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                用户口碑
              </Link>
              <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                联系方式
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">免责声明</h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              本站视频内容均来自互联网，仅供学习交流使用。如侵犯您的权益，请及时联系我们处理。本站不存储任何视频文件，所有视频链接均来自第三方。
            </p>
          </div>
        </div>

        <div className="border-t border-background-800/50 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 成全影院 chengquan.tv - 免费电影在线观看 | 电视剧全集 | 综艺大全
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors" rel="nofollow">
              用户协议
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors" rel="nofollow">
              隐私政策
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}